<template>
  <div>
    <v-toolbar class="primary elevation-0 small-extension" dark>
      <h1 class="titulo">Usuários</h1>
    </v-toolbar>
    <v-list two-line class="pa-0">
      <template v-for="(item, index) in users">
        <v-list-tile v-bind:key="item.id" :to="{ name: 'UsuariosEditar', params: { id: item.id } }">
          <v-list-tile-avatar class="avatar_sem_borda usuario-avatar">
            <img v-bind:src="item.avatar" class="avatar_borda" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ item.cargo }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
      </template>
    </v-list>
    <v-btn dark fab fixed bottom right class="secondary" :to="({ name: 'UsuariosAdicionar' })">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    mounted () {
      this.$store.dispatch('users/loadUsers')
    },
    computed: {
      users () {
        let users = this.$store.getters['users/users']

        if (this.$auth.check('Patrimônio')) {
          users = _.filter(users, { roles: ['Operacional'] })
        }

        return users
      }
    }
  }
</script>

<style scoped>
.usuario-avatar {
  margin-left: 40px;
}

@media (max-width: 599px) {
  .usuario-avatar {
    margin-left: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// UsuariosLista.vue?4fed81b5